import Tooltip from './Tooltip';

export default Tooltip;



// WEBPACK FOOTER //
// ./src/index.js